import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { Input, Button, Form, Checkbox, Row, Col, Tabs, Select, Spin } from 'antd'
import { displayMessage } from '../../helpers/messages'
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import { ERegExp } from '../../enums/ERegExp'
import ListUsersFromClient from './components/ListUsersFromClient';



export default function DetailClient() {
    const [form] = Form.useForm()
    const { idClient } = useParams()

    const [readOnly, setReadOnly] = useState(true)
    const [client, setClient] = useState(null)
    const [states, setStates] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true)
    const [quizzesToLoad, setQuizzesToLoad] = useState(null);
    const [isModalLinkToQuizOpen, setIsModalLinkToQuizOpen] = useState(false);

    let hasChanged = false

    const {
        setShowLoading,
        mobile_mode,
        windowHeight,
    } = useContext(GeneralContext)

    useEffect(() => {
        loadInitialData()
    }, [])

    async function loadInitialData() {
        try {
            await loadClientInfo(idClient)
        } finally {
            setTimeout(() => {
                setIsLoadingData(false)
            }, 1000)
        }
    }

    const loadClientInfo = async (id) => {
        try {
            let tempClient = await api.client.get(id)
            form.setFieldsValue(tempClient.data)
            setClient(tempClient.data)
        } catch (error) {
            // alert('Empresa inválida', 'warning')
        }
    }



  

    const onFinishEdit = async (values) => {
        if (readOnly) {
            setReadOnly(current => !current)
            return
        }

        setShowLoading(true)

        try {
            if (hasChanged) {
                await api.client.update(client.id, values)
                alert(displayMessage('CLIENT_DATA_SAVED_SUCCESS'), 'success', displayMessage('SUCCESS'))
            }
        } finally {
            setReadOnly(current => !current)
            setShowLoading(false)
        }
    }

    const toggleActiveState = async () => {
        setShowLoading(true)

        try {
            if (!idClient) {
                alert(displayMessage('ERROR_UPDATE_CLIENT_STATUS'), 'error', displayMessage('ERROR'))
                return
            }

            await api.client.changeActive(idClient)
            loadClientInfo(idClient)
        } catch (error) {
            alert(displayMessage('ERROR_UPDATE_CLIENT_STATUS'), 'error', displayMessage('ERROR'))
        } finally {
            setShowLoading(false)
        }
    }

    const onCloseEdit = () => {
        setReadOnly(true)
        loadClientInfo(idClient)
    }
    const onOpenEdit = () => {
        readOnly ? setReadOnly(false) : form.submit()
    }

    if (isLoadingData) {
        return (
            <div style={{ width: '100%', flex: 1, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size='large' />
            </div>
        )
    }

    return (
        <>
            <div className='font-bold text-lg text-appian-blue text-center' style={{ marginBottom: 10 }}>{displayMessage('DETAIL_CLIENT')}</div>

            <div className='flex flex-1 flex-col'>
                <Tabs
                    className='h-full'
                    defaultActiveKey="1"
                    items={[
                        {
                            key: '1',
                            label: displayMessage('DETAIL_CLIENT'),
                            children: (
                                <>
                                    <Form
                                        onFinish={onFinishEdit}
                                        layout="vertical"
                                        requiredMark='optional'
                                        form={form}
                                        disabled={readOnly}
                                        onValuesChange={() => { hasChanged = true }}
                                    >
                                        <div style={{ maxWidth: mobile_mode ? '80%' : '50%', flexDirection: 'column', gap: 2, display: 'flex' }}>
                                            <Form.Item
                                                label={<span className='text-fit-red-900 font-semibold' >{displayMessage('COMPANY_NAME')}:</span>}
                                                name="name"
                                                className={`w-full m-0`}
                                                rules={[
                                                    { required: true, message: displayMessage('COMPANY_NAME_MANDATORY') },
                                                    { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                ]}
                                            >
                                                <Input type="text" className='text-fit-red-900' />
                                            </Form.Item>

                                            <Form.Item
                                                label={<span className='text-fit-red-900 font-semibold' > {displayMessage('COMPANY_DOCUMENT')}:</span>}
                                                name="cnpj"
                                                className={`w-full m-0`}
                                                rules={[
                                                    { required: true, message: displayMessage('COMPANY_DOCUMENT_MANDATORY') },
                                                    { pattern: ERegExp.ONLY_HAVE_NUMBERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                ]}
                                            >
                                                <Input type="text" className='text-fit-red-900' maxLength={14} />
                                            </Form.Item>
                                        </div>
                                    </Form>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flex: 1, flexDirection: mobile_mode ? 'column' : 'row', maxWidth: mobile_mode ? '80%' : '50%' }}>
                                        <Button
                                            style={{ minWidth: 80, marginTop: 15, maxWidth: mobile_mode ? '100%' : 80 }}
                                            type={'primary'}
                                            onClick={() => toggleActiveState()}
                                            danger={client?.active ? false : true}
                                        >
                                            {client?.active ? displayMessage('IS_ACTIVE') : displayMessage('IS_INACTIVE')}
                                        </Button>

                                        <div style={{ display: 'flex', width: mobile_mode ? '100%' : 280, justifyContent: mobile_mode ? 'space-between' : 'flex-end', flexDirection: mobile_mode ? 'column' : 'row', }}>
                                            <Button
                                                style={{ minWidth: 80, marginTop: 15 }}
                                                type={'primary'}
                                                onClick={onOpenEdit}
                                            >
                                                {readOnly ? displayMessage('EDIT') : displayMessage('SAVE_EDIT')}
                                            </Button>
                                            {
                                                !readOnly ?
                                                    <Button
                                                        style={{ minWidth: 80, marginTop: 15, marginLeft: mobile_mode ? 0 : 10 }}
                                                        type={'primary'}
                                                        onClick={onCloseEdit}
                                                        danger

                                                    >
                                                        {displayMessage('CLOSE')}
                                                    </Button>
                                                    :
                                                    <div />
                                            }
                                        </div>
                                    </div>
                                </>
                            )
                        },
                        {
                            label: displayMessage('USER_LIST'),
                            key: '2',
                            style: { height: '100%' },
                            children: (
                                <ListUsersFromClient client={client} />
                            ),
                        }
                    ]}
                />
            </div>
        </>
    )
}